/** SUNTRONIX ONE — Today's Wins strip (ONE MOMENTS).
 *  A compact, positive-but-professional rollup of genuine wins today.
 *  Renders nothing when there are no wins (no empty motivational noise).
 */
import { useEffect, useState } from "react";
import { Trophy, PackageCheck, ShieldCheck, TrendingUp } from "lucide-react";
import api from "@/lib/api";

const ICONS = { orders_won: TrendingUp, delivered: PackageCheck, applecare: ShieldCheck };

const fmtINR = (n) => `\u20B9 ${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export default function TodayWins({ team = false }) {
  const [wins, setWins] = useState(null);
  useEffect(() => {
    api.get("/moments/wins/today").then(({ data }) => setWins(data)).catch(() => setWins(null));
  }, []);

  if (!wins || !wins.items || wins.items.length === 0) return null;

  const contributors = wins.contributors || [];

  return (
    <div data-testid="today-wins"
      className="rounded-xl border border-emerald-200 bg-gradient-to-r from-emerald-50 to-white p-4">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-emerald-700">
        <Trophy className="h-4 w-4" strokeWidth={2} /> {team ? "Team Wins Today" : "Today's Wins"}
      </div>
      <div className="mt-3 flex flex-wrap gap-6">
        {wins.items.map((w) => {
          const Icon = ICONS[w.key] || TrendingUp;
          return (
            <div key={w.key} className="flex items-center gap-2.5" data-testid={`today-win-${w.key}`}>
              <div className="h-9 w-9 rounded-lg bg-white border border-emerald-200 grid place-items-center text-emerald-600">
                <Icon className="h-4.5 w-4.5" strokeWidth={1.8} />
              </div>
              <div>
                <div className="text-lg font-bold tracking-tight text-slate-900 leading-none"
                  style={{ fontFamily: "Manrope, sans-serif" }}>
                  {w.value}{w.amount ? <span className="ml-2 text-[12px] font-medium text-emerald-700">{fmtINR(w.amount)}</span> : null}
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5">{w.label}</div>
              </div>
            </div>
          );
        })}
      </div>
      {team && contributors.length > 0 && (
        <div className="mt-3 pt-3 border-t border-emerald-100 flex flex-wrap items-center gap-2" data-testid="team-wins-contributors">
          <span className="text-[11px] font-medium text-emerald-800">Great work, team!</span>
          {contributors.map((c) => (
            <span key={c} className="text-[11px] capitalize bg-white border border-emerald-200 text-emerald-700 rounded-full px-2 py-0.5">{c}</span>
          ))}
        </div>
      )}
    </div>
  );
}
